import React, { useState } from 'react';

export default function useModal(config) {
  const defaultVisible = config?.defaultVisible || false;
  const [visible, setIsVisible] = useState(defaultVisible);

  function show() {
    setIsVisible(true);
  }

  function close() {
    setIsVisible(false);
  }

  function toggle() {
    setIsVisible(!visible);
  }
  return { visible, show, close, toggle };
}
